import React, { useState } from 'react'
import { FaEdit, FaPlus, FaTimes, FaTrash } from 'react-icons/fa';
import Card from '../../UI/Card/Card';
import MyInput from '../../UI/input/MyInput';
import MySelect from '../../UI/select/MySelect';
import MyButton from '../../UI/button/MyButton';
import GenericTable from '../../UI/table/GenericTable';
import Overlay from '../Overlay';
import InputWrapper from '../InputWrapper';
import { useDMSContext } from '../../context/DMSContext';
import debtorService from '../../services/DebtorService';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { debtorStatuses } from '../../assets/data/option';



export default function DebtorsSection() {
    const { debtors, refetchDebtors } = useDMSContext();
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(debtorStatuses[0]);
    const [overlay, setOverlay] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingDebtorId, setEditingDebtorId] = useState(null);
    const navigate = useNavigate();
    const [debtor, setDebtor] = useState({
        name: '',
        cif: '',
        totalContracts: '',
        totalDebt: '',
        totalPenalty: '',
        status: 'ACTIVE',
        address:'',
        phone:'',
        email:'',
        contactPerson:''
      });

    const handleEditDebtor = (debtorData) => {
        setDebtor(debtorData);
        setEditingDebtorId(debtorData.id);
        setIsEditing(true);
        setOverlay(true);
    };

    const deleteDebtor = async (debtorId) => {
      try {
        const response = await debtorService.deleteDebtor(debtorId);
        refetchDebtors();
        toast.success('Debitorul a fost șters cu succes');
      } catch (error) {
        toast.error('Eroare la ștergerea debitorului');
      }
    };
    

    const debtorColumns = [
        {
          Header: 'DENUMIRE DEBITOR',
          accessor: 'name',
          Cell: ({ value }) => <Link to="">{value}</Link>
        },
        { Header: 'CIF/CUI', accessor: 'cif' },
        { Header: 'TOTAL CONTRACTE', accessor: 'totalContracts' },
        {
          Header: 'TOTAL RESTANȚĂ',
          accessor: 'totalDebt',
          Cell: ({ row }) => {
            const { totalDebt, currency} = row.original;
            return <span className="text-danger">{parseFloat(totalDebt).toFixed(2)} {currency}</span>
          }
        },
        {
          Header: 'TOTAL PENALITĂȚI',
          accessor: 'totalPenalty',
          Cell: ({ row }) => {
            const { totalPenalty, currency} = row.original;
            return <span className="text-warning">{parseFloat(totalPenalty).toFixed(2)} {currency}</span>
          }
        },
        {
          Header: 'STATUS',
          accessor: 'status',
          Cell: ({ value }) => {
            const statusObj = debtorStatuses.find(s => s.value === value);
            const label = statusObj ? statusObj.label : value;
            return (<span className={value === 'ACTIVE' ? 'badge-active' : 'badge-inactive'}>
              {label}
            </span>);
          }
        },
        {
            Header: 'ACȚIUNI',
            enableCellClick: false,
            Cell: ({ row }) => (
              <div className="actions">
                <button className="edit" onClick={(e) => {e.stopPropagation();handleEditDebtor(row.original)}}>
                  <FaEdit />
                </button>
                <button className="delete" onClick={(e) => {e.stopPropagation();deleteDebtor(row.original.id)}}>
                  <FaTrash />
                </button>
              </div>
            )
          }      
      ];
    
    const handleOverlay = () => {
        setOverlay(!overlay);
    }

    const validate = () => {
      if (debtor.name == '' || debtor.name == null) {
        toast.error('Introduceți numele debitorului');
        return false;
      }
    
      if (debtor.cif == '' || debtor.cif == null) {
        toast.error('Introduceți CIF-ul debitorului');
        return false;
      }
  
      return true;
    };
    

    const submitDebtor = async (e) => {
        e.preventDefault();
        if(!validate()){
          return;
        }
      
        if (isEditing) {
          try {
            const response = await debtorService.updateDebtor(editingDebtorId, debtor);
            refetchDebtors();
            toast.success('Debitorul a fost actualizat cu succes');
          } catch (error) {
            toast.error('Eroare la actualizarea debitorului');
          }
        } else {
          try {
            const response = await debtorService.addDebtor(debtor);
            refetchDebtors();
            toast.success('Debitorul a fost adăugat cu succes');
          } catch (error) {
            toast.error('Eroare la adăugarea debitorului');
          }
          }
        setDebtor({
          name: '',
          cif: '',
          totalContracts: '',
          totalDebt: '',
          totalPenalty: '',
          status: 'ACTIVE',
          address: '',
          phone: '',
          email: '',
          contactPerson: ''
        });
        setIsEditing(false);
        setOverlay(false);
      };
      
    const setDebtorStatus = (selectedOption) => {
        setDebtor(prev => ({ ...prev, status: selectedOption?.value || '' }));
      };
      
  const filteredDebtors = debtors.filter(d =>
    (selectedStatus.value === 'Toți' || d.status === selectedStatus.value) &&
    (d.name.toLowerCase().includes(searchTerm.toLowerCase()) || d.cif.includes(searchTerm))
  );
  return (
    <div className='dms-content'>
        <div className='section-header'><h2>Lista Debitorilor</h2>
        <MyButton
        style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
        id="addDebtorBtn"
        body={ <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}><FaPlus />Adaugă Debitor Nou</span>}
        type="button"
        onClick={handleOverlay}
        />
        </div>
        <div className='flex-row'>
            <Card style={{padding:"1rem"}}>
                <div className='flex-row' style={{width:"100%"}}>
                    <div className="calc-search" style={{width:"50%"}}>
                    <MyInput
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    type="text"
                    placeholder="Caută după nume, CIF..."
                    />
                {searchTerm && (
                    <button type="button" className="clear-search-icon" onClick={null}>
                        <FaTimes />
                    </button>
                    )}
                    </div>
                    <div style={{width:"50%"}}>
                        <MySelect 
                        options={debtorStatuses} 
                        name="debtorStatuses"
                        value={selectedStatus}
                        customOnChange={(selectedOption) => setSelectedStatus(selectedOption)}
                        style
                        />
                    </div>
                </div>
            </Card>
        </div>
    <Card style={{padding:"1rem"}}>

      <GenericTable data={filteredDebtors} columns={debtorColumns}  onRowClick={(row) => navigate(`/dms/debtors/${row.original.id}`)}/>
    </Card>
    <Overlay
    handleOverlay={handleOverlay}
    isOpen={overlay}
    maxWidth='60vw'
    >
        <h2 style={{marginBottom:"2rem"}}>Adaugă Debitor Nou</h2>
        <form onSubmit={submitDebtor} className='form-container'>
                    
                        <InputWrapper
                            isRequired={true}
                            value={debtor.name}
                            onChange={(e) => setDebtor(prev => ({...prev, name:e.target.value}))}
                            type="text"
                            name='debtorName'
                            body={<>Denumirea Agentului Economic <span style={{color:"red"}}>*</span></>}
                        />


                        <InputWrapper
                            name="CIF"
                            type="text"
                            isRequired={true}
                            body={<>CIF/CUI <span style={{color:"red"}}>*</span></>}
                            value={debtor.cif}
                            onChange={(e) => setDebtor(prev => ({...prev, cif:e.target.value}))}
                            regex = {/^(\s*|\d+)$/}
                            // controlLimit = {13}
                            limit = {9}
                        />
                        <InputWrapper
                            value={debtor.address}
                            onChange={(e) => setDebtor(prev => ({...prev, address:e.target.value}))}
                            type="text"
                            name='address'
                            body="Adresă"
                        />
                        <InputWrapper
                            value={debtor.phone}
                            onChange={(e) => setDebtor(prev => ({...prev, phone:e.target.value}))}
                            type="text"
                            name='phone'
                            body="Număr de Telefon"
                            isNumeric={true}
                            isTelephoneNumber = {true}
                        />
                        <InputWrapper
                            name="email" 
                            type="email"  
                            body="Adresă de Email"
                            value={debtor.email}
                            onChange={(e) => setDebtor(prev => ({...prev, email:e.target.value}))}
                        />
                        <InputWrapper
                            value={debtor.contactPerson}
                            onChange={(e) => setDebtor(prev => ({...prev, contactPerson:e.target.value}))}
                            type="text"
                            name='contactPerson'
                            body="Persoană de Contact"
                        />
                          <div className='myInpWrapper'>
                          <label htmlFor={"debtors"} className={'myInpLabel'}>Status</label>
                            <MySelect 
                                options={debtorStatuses.filter(option => option.value !== 'Toți')}
                                name="debtorStatuses"
                                value={debtorStatuses.find(option => option.value === debtor.status)}
                                onChange={(selectedOption) => setDebtor(prev => ({...prev, status: selectedOption || ''}))}
                            />
                            </div>
                        <div className='flex-row' style={{justifyContent:"flex-end"}}>
                        <MyButton
                            style={{maxWidth:"175px",color:"var(--prolex-red)",borderColor:"var(--prolex-red)"}}
                            id="cancelBtn"
                            body="Anulează"
                            onClick={handleOverlay}
                        />
                        <MyButton
                            style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
                            id="addDebtorBtn"
                            body={<>Salvează Debitor</>}
                            type='submit'
                        />
                        </div>
        </form>
    </Overlay>

    </div>   
  )
}
